import { render, staticRenderFns } from "./TownSwiper.vue?vue&type=template&id=8a066862&scoped=true&"
import script from "./TownSwiper.vue?vue&type=script&lang=js&"
export * from "./TownSwiper.vue?vue&type=script&lang=js&"
import style0 from "./TownSwiper.vue?vue&type=style&index=0&id=8a066862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a066862",
  null
  
)

export default component.exports